import { Flex, Space } from 'antd'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import RWDCardLayout, {
  COMMON_DESKTOP_CARD_BODY_WIDTH,
  CommonCardDescription,
  CommonCardTitle,
} from '@/components/layout/rwd-card-layout'
import BackToLoginLink from '@/components/reset-password/back-to-login-link'
import { useIntl } from '@/i18n/hooks/use-intl'

const ResetPasswordSuccessView: FunctionComponent = () => {
  const { formatMessage } = useIntl()

  return (
    <RWDCardLayout cardBodyWidth={COMMON_DESKTOP_CARD_BODY_WIDTH}>
      <Flex gap={32} vertical={true}>
        <Space
          align='center'
          direction='vertical'
          size={12}
          style={{ width: '100%' }}
        >
          <CommonCardTitle>
            {formatMessage({ id: 'account:forget_psw_email_sent_title' })}
          </CommonCardTitle>
          <CommonCardDescription>
            {formatMessage({
              id: 'account:forget_psw_email_sent_description',
            })}
          </CommonCardDescription>
        </Space>
        <BackToLoginLinkWrapper>
          <BackToLoginLink />
        </BackToLoginLinkWrapper>
      </Flex>
    </RWDCardLayout>
  )
}

const BackToLoginLinkWrapper = styled.div`
  display: flex;
  justify-content: center;

  a {
    text-decoration: underline;
  }
`

export default ResetPasswordSuccessView
